import { RequestException } from '@eika-infrastruktur/request/src/exceptions';

export enum RemoteDataType {
    NOT_ASKED = 'NOT_ASKED',
    LOADING = 'LOADING',
    SUCCESS = 'SUCCESS',
    FAILURE = 'FAILURE',
}

interface NotAsked {
    type: RemoteDataType.NOT_ASKED;
}

interface Loading {
    type: RemoteDataType.LOADING;
}

interface Success<T> {
    type: RemoteDataType.SUCCESS;
    data: T;
}

interface Failure {
    type: RemoteDataType.FAILURE;
    exception: RequestException;
}

export type RemoteData<T> = NotAsked | Loading | Success<T> | Failure;

export const notAsked = (): NotAsked => ({
    type: RemoteDataType.NOT_ASKED,
});

export const loading = (): Loading => ({
    type: RemoteDataType.LOADING,
});

export const success = <T>(data: T): Success<T> => ({
    type: RemoteDataType.SUCCESS,
    data,
});

export const failure = (exception: RequestException): Failure => ({
    type: RemoteDataType.FAILURE,
    exception,
});

export const mapSuccess = <T, U>(remoteData: RemoteData<T>, func: (data: T) => U): RemoteData<U> => {
    switch (remoteData.type) {
        case RemoteDataType.SUCCESS:
            return success(func(remoteData.data));
        case RemoteDataType.FAILURE:
            return failure(remoteData.exception);
        case RemoteDataType.LOADING:
            return loading();
        case RemoteDataType.NOT_ASKED:
            return notAsked();
        default:
            return remoteData;
    }
};
